// extracted by css-extract-rspack-plugin
export default {"CollapseButton":"L9oDJ"};